import ApiService, { HttpMethod } from "../../commons/api/api_service";
import BaseResponse from "../../commons/api/base_response";
import { Endpoints } from "../../commons/api/endpoints";
import { ProviderVM } from "../../commons/base/providers/view_model";
import OutletCompletionInfoModel from "../models/completion_info_model";
import { MenuCategory } from "../models/menu_category_enum";
import {
    SoldOutLocationCountModel,
    SoldOutPerOutletModel,
    SoldOutResponse,
} from "../models/sold_out_model";

export default class SoldOutAndCompletionDashboardViewModel extends ProviderVM {
    // Completion
    completionData: OutletCompletionInfoModel[] = [];
    completionErrorMessage: string = "";

    // Sold out
    isShowingSoldOutModal: boolean = false;
    isShowingSoldOutOtherMenus: boolean = false;
    soldOutErrorMessage: string = "";
    soldOutPerOutletMap: Map<string, SoldOutPerOutletModel> = new Map<
        string,
        SoldOutPerOutletModel
    >();
    filteredPrioritySoldOutData: SoldOutPerOutletModel[] = [];
    filteredOtherSoldOutData: SoldOutPerOutletModel[] = [];
    soldOutLocationCountMap: SoldOutLocationCountModel[] = [];

    constructor() {
        super();
        this.loadCompletion();
        this.loadSoldOutData();
    }

    // Completion
    loadCompletion() {
        ApiService.fetch(Endpoints.completionInfo, {
            onSuccess: (
                response: BaseResponse<{ data: OutletCompletionInfoModel[] }>
            ) => {
                const completionData = response.data
                    ?.data as OutletCompletionInfoModel[];
                this.emit(() => {
                    this.completionData = completionData;
                    this.completionErrorMessage = "";
                });

                setTimeout(() => this.loadCompletion(), 20000);
            },
            onFailure: (error) => {
                console.log("Error in loadCompletion : ", error);
                this.emit(() => {
                    this.completionErrorMessage =
                        "Gagal memuat data cooking time, harap refresh halaman ini!";
                });
            },
        });
    }

    // Sold out

    loadSoldOutData() {
        ApiService.fetch<{}, BaseResponse<SoldOutResponse[]>>(
            Endpoints.getSoldOutMenu,
            {
                httpMethod: HttpMethod.post,
                onSuccess: (result) => {
                    if (result?.data) {
                        const soldOutResponse = result.data.filter(
                            (data) => data.menus.length > 0
                        );

                        // Filter menu untuk ditampilkan di tabel
                        const filteredSoldOutMap = new Map<
                            string,
                            SoldOutPerOutletModel
                        >();
                        soldOutResponse.forEach((data) => {
                            if (!filteredSoldOutMap.has(data.outlet)) {
                                const chiliOilMenus: string[] = [];
                                const b1g1Menus: string[] = [];
                                const geprekMenus: string[] = [];
                                const mainCourseMenus: string[] = [];
                                const otherMenus: string[] = [];

                                data.menus.forEach((menu) => {
                                    switch (menu.category) {
                                        case MenuCategory.CHILI_OIL:
                                            chiliOilMenus.push(...menu.name);
                                            break;
                                        case MenuCategory.B1G1:
                                            b1g1Menus.push(...menu.name);
                                            break;
                                        case MenuCategory.GEPREK:
                                            geprekMenus.push(...menu.name);
                                            break;
                                        case MenuCategory.MAIN_COURSE:
                                            mainCourseMenus.push(...menu.name);
                                            break;
                                        default:
                                            otherMenus.push(...menu.name);
                                            break;
                                    }
                                });

                                filteredSoldOutMap.set(data.outlet, {
                                    outletName: data.outlet,
                                    chiliOilMenus: chiliOilMenus,
                                    b1g1Menus: b1g1Menus,
                                    geprekMenus: geprekMenus,
                                    mainCourseMenus: mainCourseMenus,
                                    otherMenus: otherMenus,
                                });
                            }
                        });

                        // Hitung jumlah lokasi setiap menu sold out
                        const soldOutLocationCountMap = new Map<
                            string,
                            SoldOutLocationCountModel
                        >();

                        soldOutResponse.forEach((location) => {
                            location.menus.forEach((menuList) => {
                                menuList.name.forEach((name) => {
                                    const oldModel =
                                        soldOutLocationCountMap.get(name);
                                    if (oldModel) {
                                        soldOutLocationCountMap.set(name, {
                                            name: oldModel.name,
                                            count: oldModel.count + 1,
                                            category: oldModel.category,
                                        });
                                    } else {
                                        soldOutLocationCountMap.set(name, {
                                            name: name,
                                            count: 1,
                                            category:
                                                menuList.category as MenuCategory,
                                        });
                                    }
                                });
                            });
                        });

                        const sortedSoldOutLocationCountMap =
                            this._sortCumulativeSoldOutDataByPriority({
                                soldOutCumulativeData: Array.from(
                                    soldOutLocationCountMap.values()
                                ),
                                priorityOrder: [
                                    MenuCategory.CHILI_OIL,
                                    MenuCategory.B1G1,
                                    MenuCategory.GEPREK,
                                    MenuCategory.MAIN_COURSE,
                                ],
                            });

                        this.emit(() => {
                            this.soldOutPerOutletMap = filteredSoldOutMap;
                            this.soldOutLocationCountMap =
                                sortedSoldOutLocationCountMap;
                            this.filteredPrioritySoldOutData = Array.from(
                                filteredSoldOutMap.values()
                            ).filter(
                                (value) =>
                                    value.b1g1Menus.length > 0 ||
                                    value.chiliOilMenus.length > 0 ||
                                    value.geprekMenus.length > 0 ||
                                    value.mainCourseMenus.length > 0
                            );
                            this.filteredOtherSoldOutData = Array.from(
                                filteredSoldOutMap.values()
                            ).filter((value) => value.otherMenus.length > 0);
                            this.soldOutErrorMessage = "";
                        });

                        setTimeout(() => this.loadSoldOutData(), 60000);
                    } else {
                        console.log("Error in loadSoldOutData() : ", result);
                        this.emit(() => {
                            this.soldOutErrorMessage =
                                "Gagal mendapatkan data, tolong REFRESH halaman ini";
                        });
                    }
                },
                onFailure: (error) => {
                    console.log("Error in loadSoldOutData() : ", error);
                    this.emit(() => {
                        this.soldOutErrorMessage =
                            "Gagal mendapatkan data, tolong REFRESH halaman ini";
                    });
                },
            }
        );
    }

    _sortCumulativeSoldOutDataByPriority(args: {
        soldOutCumulativeData: SoldOutLocationCountModel[];
        priorityOrder: MenuCategory[];
    }): SoldOutLocationCountModel[] {
        const { soldOutCumulativeData, priorityOrder } = args;
        const sortedData = [];

        for (const priority of priorityOrder) {
            const filteredDataByPriority = soldOutCumulativeData.filter(
                (value) => (value.category as MenuCategory) === priority
            );
            sortedData.push(...filteredDataByPriority);
        }

        const otherData = soldOutCumulativeData.filter(
            (value) => !priorityOrder.includes(value.category as MenuCategory)
        );
        sortedData.push(...otherData);

        return sortedData;
    }

    setIsShowingSoldOutModal(value: boolean) {
        this.emit(() => {
            this.isShowingSoldOutModal = value;
        });
    }

    setIsShowingOtherSoldOutMenus(value: boolean) {
        this.emit(() => {
            this.isShowingSoldOutOtherMenus = value;
        });
    }
}
